import { render, staticRenderFns } from "./PhilhealthContributionMain.vue?vue&type=template&id=c2206d0c"
import script from "./PhilhealthContributionMain.vue?vue&type=script&lang=js"
export * from "./PhilhealthContributionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports